var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-basic',[_c('div',{staticClass:"container has-text-centered",attrs:{"slot":"hero-body"},slot:"hero-body"},[_c('h1',{staticClass:"title"},[_vm._v("\n      Cloudprinter to Zoho CRM\n    ")])]),_c('div',{staticClass:"section"},[_vm._v("\n    Contact Cloudprinter.com support team if you need help - support@cloudprinter.com\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }